import { z } from 'zod';

export const messageFormDataSchema = z.object({
  message: z.string().nullish(),
  dismissOtherSuppliers: z.boolean(),
  informDismissedSuppliers: z.boolean(),
  informAwardedSupplier: z.boolean(),
});

export type MessageFormData = z.infer<typeof messageFormDataSchema>;
